import Configs from 'infrastructure/config/environment'

export function curriculumUrl(treeId: string, treeVer: string): string {
  return `${Configs().AppUrl}/curriculum/${treeId}:${treeVer}`
}
